import React, { Suspense, lazy } from 'react';
import { HeroSection } from '../components/HeroSection';
import { StickyCTA } from '../components/StickyCTA';
const TrustBar = lazy(() => import('../components/TrustBar').then(m => ({
  default: m.TrustBar
})));
const ContrastSection = lazy(() => import('../components/ContrastSection').then(m => ({
  default: m.ContrastSection
})));
const ForWhomSection = lazy(() => import('../components/ForWhomSection').then(m => ({
  default: m.ForWhomSection
})));
const BenefitsSection = lazy(() => import('../components/BenefitsSection').then(m => ({
  default: m.BenefitsSection
})));
const ContentPreview = lazy(() => import('../components/ContentPreview').then(m => ({
  default: m.ContentPreview
})));
const BonusSection = lazy(() => import('../components/BonusSection').then(m => ({
  default: m.BonusSection
})));
const PricingSection = lazy(() => import('../components/PricingSection').then(m => ({
  default: m.PricingSection
})));
const GuaranteeSection = lazy(() => import('../components/GuaranteeSection').then(m => ({
  default: m.GuaranteeSection
})));
const TestimonialsSection = lazy(() => import('../components/TestimonialsSection').then(m => ({
  default: m.TestimonialsSection
})));
const ExpertSection = lazy(() => import('../components/ExpertSection').then(m => ({
  default: m.ExpertSection
})));
const FAQSection = lazy(() => import('../components/FAQSection').then(m => ({
  default: m.FAQSection
})));
const Footer = lazy(() => import('../components/Footer').then(m => ({
  default: m.Footer
})));
const SocialProofPopup = lazy(() => import('../components/SocialProofPopup').then(m => ({
  default: m.SocialProofPopup
})));
export function LandingPage() {
  return <main className="w-full min-h-screen bg-bg-main font-inter selection:bg-primary/30" data-id="element-248">
      <div data-id="element-249">
        <HeroSection data-id="element-250" />

        <Suspense fallback={null} data-id="element-251">
          <TrustBar data-id="element-252" />
          <ContrastSection data-id="element-253" />
          <ForWhomSection data-id="element-254" />
          <BenefitsSection data-id="element-255" />
          <ContentPreview data-id="element-256" />
          <BonusSection data-id="element-257" />
          <PricingSection data-id="element-258" />
        </Suspense>

        <Suspense fallback={null} data-id="element-259">
          <GuaranteeSection data-id="element-260" />
          <TestimonialsSection data-id="element-261" />
          <ExpertSection data-id="element-262" />
          <FAQSection data-id="element-263" />
          <Footer data-id="element-264" />
          <SocialProofPopup data-id="element-265" />
          <StickyCTA data-id="element-266" />
        </Suspense>
      </div>
    </main>;
}